<template>
  <v-container fluid tag="section">
     <base-material-table
      outlined
      :item="item"
      ref="table"
      :excel="excel"
      single-expand
      >
      <template v-slot:condition>
        <v-col cols="12" md='2'>
          <v-select
            :items="[{ text: '有请假', value: 1 },{ text: '无请假', value: 0 }]"
            label="请假状态"
            v-model="item.params.travelStatus"
            hide-details='auto'
            outlined dense
            clearable
            @change="loadData"
            clear-icon="mdi-close-circle-outline"
          ></v-select>
        </v-col>
        <v-col cols="12" md='2'>
          <v-select
            :items="[{ text: '有迟到', value: 1 },{ text: '无迟到', value: 0 }]"
            label="迟到状态"
            v-model="item.params.lateStatus"
            hide-details='auto'
            outlined dense
            clearable
            @change="loadData"
            clear-icon="mdi-close-circle-outline"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            hide-details
            outlined dense
            label="年份选择"
            :items='yearItems'
            @change="loadData"
            item-text="label"
            item-value="value"
            v-model='item.params.year'>
          </v-select>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            hide-details
            outlined dense
            label="月份选择"
            :items="monthItems"
            @change="loadData"
            item-text="label"
            item-value="value"
            v-model='item.params.month'>
          </v-select>
        </v-col>
      </template>
    </base-material-table>
    <clock-in :item="clockInModal"></clock-in>
  </v-container>
</template>

<script>
  import { selectData, selectMonthData } from '@/utils/tool.js'
  import ClockIn from '@/views/pages/pc/dashboard/personal/components/ClockInDetail.vue'

  export default {
    name: 'OfficeCheck',
    components: {
      ClockIn
    },
    data() {
      return {
        monthItems: selectMonthData(),
        yearItems: selectData(3),
        clockInModal: { show: false },
        item: {
          mobile: true,
          path: 'office/check/list',
          topButtons: [
            { event: 'search', show: true },
            { event: 'download', show: true },
          ],
          sort: {
            orderByField: 'tab_.uid',
            asc: false
          },
          params: {
            month: Number(this.$moment().format('MM')),
            year: Number(this.$moment().format('YYYY')),
            travelStatus: '',
            lateStatus: ''
          },
          headers: [
            {
              text: '头像',
              align: 'center',
              divider: true,
              sortable: false,
              value: 'avatar',
              mobile: true,
              width: 100,
              avatar: (val) => val
            },
            {
              text: '姓名',
              align: 'center',
              divider: true,
              sortable: false,
              value: 'name',
              mobile: true,
              width: 100,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              search: { type: 'input', mobile: true }
            },
            {
              text: '应出勤(天)',
              align: 'center',
              divider: true,
              value: 'workDay',
              mobile: true,
              sortable: false,
              width: 120,
            },
            {
              text: '实际出勤(天)',
              value: 'actions',
              align: 'center',
              sortable: false,
              mobile: true,
              width: 120,
              divider: true,
              actions: [
                {
                  dtext: (row) => `${row.workedDay - row.travelDuration}天`,
                  color: 'primary',
                  onClick: (row) => this.clockInModal = { show: true, data: { month: this.item.params.month, year: this.item.params.year, uid: row.uid } },
                  disable: () => false
                }
              ]
            },
            {
              text: '请假(天)',
              align: 'center',
              divider: true,
              value: 'travelDuration',
              mobile: true,
              sortable: false,
              width: 120,
            },
            {
              text: '调休(天)',
              align: 'center',
              divider: true,
              value: 'leaveDuration',
              mobile: true,
              sortable: false,
              width: 120,
            },
            {
              text: '加班(小时)',
              align: 'center',
              divider: true,
              value: 'otDuration',
              mobile: true,
              sortable: false,
              width: 120,
            },
            {
              text: '出差(天)',
              align: 'center',
              divider: true,
              value: 'businessDuration',
              mobile: true,
              sortable: false,
              width: 120,
            },
            {
              text: '迟到',
              align: 'center',
              divider: true,
              value: 'lateCount',
              mobile: true,
              sortable: false,
              width: 120,
            },
            {
              text: '缺卡',
              align: 'center',
              divider: true,
              value: 'missingCount',
              mobile: true,
              sortable: false,
              width: 120,
            },
            {
              text: '日报未写',
              align: 'center',
              divider: true,
              value: 'dayReport',
              mobile: true,
              sortable: false,
              width: 120,
              formatter: (val, row) => (row.needDayReport - val < 0 ? 0 : row.needDayReport - val)
            },
            {
              text: '周报未写',
              align: 'center',
              divider: true,
              value: 'weekReport',
              mobile: true,
              sortable: false,
              width: 120,
              formatter: (val, row) => (row.needWeekReport - val < 0 ? 0 : row.needWeekReport - val)
            },
            {
              text: '通话缺少量',
              align: 'center',
              divider: true,
              value: 'callLack',
              mobile: true,
              sortable: false,
              width: 120,
            }
          ]
        },
        excel: {
          path: 'office/check/down',
          filename: `考勤明细.xls`,
          fields: {
            员工姓名: 'name',
            应出勤天数: 'workDay',
            实际出勤天数: 'workedDay',
            请假天数: 'travelDuration',
            调休天数: 'leaveDuration',
            出差天数: 'businessDuration',
            加班小时数: 'otDuration',
            迟到次数: 'lateCount',
            汇报缺少: 'reportLack',
            考勤月度: {
              field: 'month',
              callback: (value) => `${value}.`
            }
          }
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style>
</style>
